export enum TableNames {
  PUSH_TO_SFTP_MODAL_TABLE = "push_to_sftp_modal_table",
  DOWNLOAD_FILES_MODAL_TABLE = "download_files_modal_table",
  SFTP_PUSH_PENDING_RECORDS_TABLE = "sftp_push_pending_records_table",
  SFTP_SUMMARY_TABLE = "sftp_summary_table",
  SFTP_SUMMARY_RESPONSE_STATUS_TABLE = "sftp_summary_response_status_table",
  SFTP_SUMMARY_TEXT_NOTES_TABLE = "sftp_summary_text_notes_table",
  MY_PA_ORDERS = "my_pa_orders",
  MEDICAL_PA_ORDERS_NEW = "medical_pa_orders_new",
  ALL_PA_ORDERS = "all_pa_orders",
  GENERIC_AUTH_STATUS_ORDERS = "generic_auth_status_table",
  DRAFT_SUBMISSION_CPT_TABLE = "draft_submission_cpt_table",
  MY_PA_ORDERS_FROM_ALGOLIA = "my_pa_orders_from_algolia",
  PHARMA_STP_FILE_ORDERS = "pharma_stp_file_orders",
  NYCBS_EXTERNAL_ORDERS = "nycbs_external_orders",
  NYCBS_EXTERNAL_LOGS_STAGES_TABLE = "nycbs_external_logs_stages_table",
  CALLING_WORKLIST_ORDERS = "calling_worklist_orders",
  PENDING_WORKLIST_ORDERS = "pending_worklist_orders",
  PHARMA_PRIMARY_CARE_ORDERS = "pharma_primary_care_orders",
  ONCOLOGY_SUBMISSION_ORDERS = "oncology_submission_orders",
  ONCOLOGY_CASE_APPEALS_ORDERS = "oncology_case_appeals_orders",
  ASTERA_ONCOLOGY_EXTERNAL_ORDERS = "astera_oncology_external_orders",
}
